import { render } from "./ModifierOrganisation.vue?vue&type=template&id=4e322b10&ts=true"
import script from "./ModifierOrganisation.vue?vue&type=script&lang=ts"
export * from "./ModifierOrganisation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__